import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AppProvider } from './context/AppContext';
import { AppShell } from './components/AppShell';
import Capture from './pages/Capture';
import SmartLists from './pages/SmartLists';
import Schedule from './pages/Schedule';
import Completed from './pages/Completed';
import Settings from './pages/Settings';
import './App.css';

export default function App() {
  return <BrowserRouter><AppProvider><Routes><Route element={<AppShell />}>
    <Route index element={<Capture />} />
    <Route path="lists" element={<SmartLists />} />
    <Route path="schedule" element={<Schedule />} />
    <Route path="completed" element={<Completed />} />
    <Route path="settings" element={<Settings />} />
    <Route path="auth/callback" element={<Capture />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Route></Routes><Toaster position="top-center" richColors closeButton /></AppProvider></BrowserRouter>;
}